import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/games")({
  beforeLoad: () => {
    throw redirect({ statusCode: 301, to: "/explore" });
  },
});
